import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  CustomizeGroupSettings: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
    gap: '16px',
    width: '100%',
  },
  DeleteButton: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    height: '100%',
  },
  BoxGroupOption: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    gap: '8px',
  },
}));

export { useStyles };
